import { render, staticRenderFns } from "./CallFlowSetup.vue?vue&type=template&id=5ffafc6f&scoped=true&"
import script from "./CallFlowSetup.vue?vue&type=script&lang=js&"
export * from "./CallFlowSetup.vue?vue&type=script&lang=js&"
import style0 from "./CallFlowSetup.vue?vue&type=style&index=0&id=5ffafc6f&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ffafc6f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VIcon,VRow,VSheet,VTextField})
